export const countNewPrice = (price: number, discount = 0) => {
  const newPrice = +price * (1 - discount / 100);
  return newPrice;
};
